import { Loader2 } from "lucide-react";

/** Full-screen overlay shown while the AI is scoring a finished session. */
const EndingOverlay = ({ ending }) => {
  if (!ending) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-novatus-bg/95 backdrop-blur-sm flex items-center justify-center px-6" data-testid="ending-overlay">
      <div className="nv-card p-8 sm:p-10 max-w-md text-center animate-slide-up">
        <div className="w-16 h-16 mx-auto rounded-full bg-novatus-green/15 border-2 border-novatus-green/40 flex items-center justify-center mb-5">
          <Loader2 className="w-8 h-8 text-novatus-green animate-spin" />
        </div>
        <h2 className="font-display font-black text-2xl text-white">KI bewertet deinen Anruf …</h2>
        <p className="text-novatus-text-2 text-sm mt-3 leading-relaxed">
          Stärken, Verbesserungspotenzial und Kategorie-Scores werden gerade ermittelt. Dauert ca. 5-10 Sekunden.
        </p>
        <div className="mt-5 flex items-center justify-center gap-2 text-xs text-novatus-text-3">
          <span className="inline-block w-1.5 h-1.5 rounded-full bg-novatus-green animate-pulse" />
          <span>Bitte nicht zurück oder den Tab schließen</span>
        </div>
      </div>
    </div>
  );
};

export default EndingOverlay;
